export default {
  en: {
    title: 'Something went wrong',
    subtitle: 'Please return to login.',
  },
};
